export default __webpack_public_path__ + "static/media/icon_hallinto_aloittamatta.7e800a4d.svg";